module.exports = __webpack_public_path__ + "img/上聯_LOGO_320x150.e4bf7a85.png";